import { render, staticRenderFns } from "./SweetModalTab.vue?vue&type=template&id=a2a98690&"
import script from "./SweetModalTab.vue?vue&type=script&lang=js&"
export * from "./SweetModalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\sweet-modal-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2a98690')) {
      api.createRecord('a2a98690', component.options)
    } else {
      api.reload('a2a98690', component.options)
    }
    module.hot.accept("./SweetModalTab.vue?vue&type=template&id=a2a98690&", function () {
      api.rerender('a2a98690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SweetModalTab.vue"
export default component.exports